import { useEffect, useState } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import { Flex, Table, Typography } from "antd"

import { getTopology as getTopologyAPI } from "@/apis/instance";
import { RightOutlined } from "@ant-design/icons";
import { RefreshButton } from "@/components/common/RefreshButton";

export const InstanceTopologyPanel = () => {
  const [applications, setApplications] = useState([]);
  const [nodegroups, setNodegroups] = useState([]);
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedInstance] } = state;
  const id = selectedInstance?.id;
  const type = selectedInstance.type;
  const { Title } = Typography;
  const applicationColumns = [
    {
      title: 'Helm',
      dataIndex: 'helm',
      key: 'helm'
    },
    {
      title: 'Component',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Replicas',
      dataIndex: 'replicas',
      key: 'replicas'
    },
    {
      title: 'Desired replicas',
      dataIndex: 'desired_replicas',
      key: 'desired_replicas'
    },
    {
      title: 'Core',
      dataIndex: 'core',
      key: 'core'
    },
    {
      title: 'Memory',
      dataIndex: 'memory',
      key: 'memory'
    },
    {
      title: 'Java Opts',
      dataIndex: 'javaOpts',
      key: 'javaOpts'
    }
  ];
  const nodegroupColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    }, {
      title: 'Machine',
      dataIndex: 'instanceTypes',
      key: 'instanceTypes'
    }, {
      title: 'Desired Size',
      dataIndex: 'desiredSize',
      key: 'desiredSize'
    }, {
      title: 'Disk',
      dataIndex: 'disk',
      key: 'disk'
    }
  ];

  const getTopology = async (id) => {
    try {
      const response = await getTopologyAPI(id);
      if (response.status === "OK") {
        setApplications(response.value?.applications || []);
        setNodegroups(response.value?.nodegroups || []);
      } else {
        setApplications([]);
        setNodegroups([]);
      }
    } catch (error) {
      console.error("get topology failed:", error);
    }
  };
  useEffect(() => {
    getTopology(id);
  }, [id, type]);

  return (
    <div>
      {selectedInstance && selectedInstance.type == 'silo' && <Flex justify="space-between" align="center">
        <div><RightOutlined /> Nodegroups</div>
        <RefreshButton onClick={() => {
          getTopology(id);
        }} />
      </Flex>}
      {selectedInstance && selectedInstance.type == 'silo' && <Table dataSource={nodegroups} columns={nodegroupColumns} />}
      {<Flex justify="space-between" align="center" style={{ paddingBottom: '5px' }}>
        <div><RightOutlined /> Applications</div>
        <RefreshButton onClick={() => {
          getTopology(id);
        }} />
      </Flex>}
      {selectedInstance && <Table dataSource={applications} columns={applicationColumns} />}
    </div>
  );
}; 